import PropTypes from 'prop-types';

import Stack from '@zenbusiness/zui/Stack';

import { PAYMENT_STATUS } from '../../constants/payment';
import { SECTION_COMPONENTS } from '../../constants/sectionComponents';
import { SECTION_KEYS } from '../../constants/sections';
import { useCheckoutSubmission } from '../../hooks/useCheckoutSubmission';
import { usePaymentContext } from '../../hooks/usePaymentContext';

function CheckoutCardList({ onOrderSuccess, sections }) {
  const { processOrder, validateOrderForm } = useCheckoutSubmission({
    onOrderSuccess,
    sections
  });
  const [paymentState] = usePaymentContext();
  const isPaymentPending = paymentState.status === PAYMENT_STATUS.PENDING;

  return (
    <Stack spacing={2}>
      {sections.map((sectionKey, index) => {
        const SectionComponent = SECTION_COMPONENTS[sectionKey];

        if (!SectionComponent) {
          return null;
        }

        const isPaymentSection = sectionKey === SECTION_KEYS.PAYMENT_INFO;

        return (
          <SectionComponent
            key={sectionKey}
            hideEdit={isPaymentPending}
            sectionNumber={index + 1}
            {...(isPaymentSection && {
              onProcessOrder: processOrder,
              onValidateOrderForm: validateOrderForm
            })}
          />
        );
      })}
    </Stack>
  );
}

CheckoutCardList.propTypes = {
  onOrderSuccess: PropTypes.func.isRequired,
  sections: PropTypes.arrayOf(PropTypes.oneOf(Object.values(SECTION_KEYS))).isRequired
};

export default CheckoutCardList;
